<template>
  <header id="header">
    <div class="startp-mobile-nav">
      <div class="logo">
        <router-link to="/"><img src="/img/logo.png" alt="logo"></router-link>
      </div>
      <div class="mean-bar" v-if="isMobileMenuVisible">
        <a href="#" class="meanmenu-reveal" 
           @click.prevent="toggleMobileMenu"
           :class="{ 'meanclose': isMobileMenuOpen }">
          <span v-if="!isMobileMenuOpen"></span>
          <span v-if="!isMobileMenuOpen"></span>
          <span v-if="!isMobileMenuOpen"></span>
          <span v-if="isMobileMenuOpen" class="mean-close">X</span>
        </a>
        <nav class="mean-nav" v-show="isMobileMenuOpen">
          <ul>
            <li class="nav-item">
              <router-link to="/" class="nav-link" active-class="active">{{ t('nav_home') }}</router-link>
            </li>

            <li class="nav-item">
              <router-link to="/services" class="nav-link" active-class="active">{{ t('nav_services') }}</router-link>
            </li>

            <li class="nav-item">
              <router-link to="/rest" class="nav-link" active-class="active">{{ t('nav_rest_doc') }}</router-link>
            </li>
            
            <li class="nav-item">
              <router-link to="/article" class="nav-link" active-class="active">{{ t('nav_news') }}</router-link>
            </li>
            
            <li class="nav-item">
              <router-link to="/contact" class="nav-link" active-class="active">{{ t('nav_contact') }}</router-link>
            </li>
            
            <li class="nav-item">
              <a href="https://hub.atonline.com/" target="_blank" class="nav-link">{{ t('nav_customer_area') }}</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="startp-nav">
      <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
          <router-link class="navbar-brand" to="/"><img src="/img/logo.png" alt="logo"></router-link>

          <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
            <ul class="navbar-nav nav ml-auto">
              <li class="nav-item">
                <router-link to="/" class="nav-link" active-class="active">{{ t('nav_home') }}</router-link>
              </li>

              <li class="nav-item">
                <router-link to="/services" class="nav-link" active-class="active">{{ t('nav_services') }}</router-link>
              </li>

              <li class="nav-item">
                <router-link to="/rest" class="nav-link" active-class="active">{{ t('nav_rest_doc') }}</router-link>
              </li>
              
              <li class="nav-item">
                <router-link to="/article" class="nav-link" active-class="active">{{ t('nav_news') }}</router-link>
              </li>
              
              <li class="nav-item mobile-only">
                <router-link to="/contact" class="nav-link" active-class="active">{{ t('nav_contact') }}</router-link>
              </li>
              
              <li class="nav-item mobile-only">
                <a href="https://hub.atonline.com/" target="_blank" class="nav-link">{{ t('nav_customer_area') }}</a>
              </li>
            </ul>
          </div>

          <div class="others-option">
            <router-link to="/contact" class="btn btn-light">{{ t('nav_contact') }}</router-link>
            <a href="https://hub.atonline.com/" target="_blank" class="btn btn-primary">{{ t('nav_customer_area') }}</a>
          </div>
        </nav>
      </div> 
    </div>
  </header>
</template>

<script>
import i18next from '../i18next.js'
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'SiteHeader',
  setup() {
    // Simple translation function
    const t = (key) => i18next.t(key);
    
    // Mobile menu state
    const isMobileMenuOpen = ref(false);
    const isMobileMenuVisible = ref(false);
    const mobileBreakpoint = 991;
    
    // Toggle mobile menu
    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value;
    };
    
    // Check if mobile view should be shown
    const checkMobileView = () => {
      isMobileMenuVisible.value = window.innerWidth <= mobileBreakpoint;
    };
    
    // Set up event listeners
    onMounted(() => {
      checkMobileView();
      window.addEventListener('resize', checkMobileView);
    });
    
    // Clean up event listeners
    onUnmounted(() => {
      window.removeEventListener('resize', checkMobileView);
    });
    
    return { 
      t, 
      isMobileMenuOpen,
      isMobileMenuVisible,
      toggleMobileMenu
    }
  }
}
</script>

<style scoped>
/* Header styling is handled in the imported CSS */
.mobile-only {
  display: none;
}

@media only screen and (max-width: 991px) {
  .mobile-only {
    display: block;
  }
  .others-option {
    display: none;
  }
}

/* Custom styles for mobile menu */
.meanmenu-reveal {
  width: 35px;
  height: 30px;
  padding: 12px 15px 0 0;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  color: #0e314c;
  text-decoration: none;
  text-indent: -9999em;
  line-height: 22px;
  display: block;
  font-weight: 700;
}

.meanmenu-reveal span {
  display: block;
  background: #0e314c;
  height: 4px;
  margin-top: 3px;
  border-radius: 3px;
}

.mean-close {
  display: block;
  font-size: 18px;
  text-indent: 0;
  text-align: center;
  color: #0e314c;
}
</style>